import React from 'react';
import Table from '../../common/Table';

const Dashboard = () => (
    <div>
        Dashboard Page
        <Table />
    </div>
);

export default Dashboard;
